import * as THREE from 'three';
import type { DebugMaterialMode } from './fabVisualConfig';

const NEUTRAL_GRAY = '#8A9098';

/** Part 59/60/61 — reference comparison debug overrides. */
export function createFabDebugOverrideMaterial(mode: DebugMaterialMode): THREE.Material {
  switch (mode) {
    case 'wireframe':
      return new THREE.MeshBasicMaterial({
        color: NEUTRAL_GRAY,
        wireframe: true,
      });
    case 'neutral':
    case 'material':
      return new THREE.MeshStandardMaterial({
        color: NEUTRAL_GRAY,
        metalness: 0.08,
        roughness: 0.55,
        envMapIntensity: mode === 'material' ? 0.15 : 0,
      });
    case 'glass':
      return new THREE.MeshStandardMaterial({
        color: '#6A727A',
        metalness: 0.05,
        roughness: 0.35,
        transparent: true,
        opacity: 0.92,
      });
    case 'lighting':
      return new THREE.MeshStandardMaterial({
        color: '#9AA0A8',
        metalness: 0.06,
        roughness: 0.48,
        envMapIntensity: 0.25,
      });
    default:
      return new THREE.MeshStandardMaterial({ color: NEUTRAL_GRAY });
  }
}

export function shouldDisablePostForDebug(mode: DebugMaterialMode | null): boolean {
  return mode === 'material' || mode === 'lighting' || mode === 'neutral';
}
